import Vue from 'vue';

async function presignedUrl (key, folder) {
    try {
        const response = await Vue.axios.post('/getImage', {
            uuid: key,
            folder: folder
        });

        return response.data.url;
    } catch (err) {
        console.log('err', err);
    }
}

export default presignedUrl;
